import './ContentClipper.less';
import { useSectionData } from '../../Sections/useSectionContext';
import { useEffectivePageSize } from 'hooks/useEffectivePageSize';
interface ContentClipperProps {
  blockId: string;
}
export default function ContentClipper({ blockId }: ContentClipperProps) {
  const canvasWidth = useEffectivePageSize().width;
  const { blocksContent } = useSectionData();
  const blockData = blocksContent[blockId];

  // If blockData is undefined, it might be a signature or another block type not in blocksContent
  if (!blockData) {
    return null;
  }

  const {
    blockConfig: { x: xAxis, y: yAxis, width },
  } = blockData;

  const rightOverflown = width + xAxis - canvasWidth;
  const widthToHide = rightOverflown < 0 ? 0 : rightOverflown;
  const leftPosition = canvasWidth - xAxis;

  const topOverflown = yAxis;
  const heightToHideTop = topOverflown < 0 ? -topOverflown : 0;

  const leftOverflown = xAxis;
  const widthToHideLeft = leftOverflown < 0 ? -leftOverflown : 0;

  return (
    <>
      <div
        className="right-clipper"
        style={{
          left: leftPosition,
          width: widthToHide,
        }}
      />
      <div
        className="top-clipper"
        style={{
          height: heightToHideTop,
        }}
      />
      <div
        className="left-clipper"
        style={{
          width: widthToHideLeft,
        }}
      />
    </>
  );
}
